import { Component, Input } from "@angular/core";

@Component({
  selector: 'tab',
  styleUrls: ['./tabs.css'],
  template: `
    <ng-content *ngIf="active"></ng-content>
  `
})
export class TabComponent {

  @Input() title = '';
  @Input() active = false;
  @Input() disabled = false;

}


// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/tabset/tab.component.ts